import { usePlanningStore } from '@planning/AppProvider'
import { useTranslate } from '@tolgee/react'
import { Header, useMinimalsTheme } from '@tom-ui/ui'
import { PATHS, useHistory } from '@tom-ui/utils'

import { Box, Button } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router'
import { ExternalDriverForm } from './Components/Molecules/ExternalDriverForm'
import { useExternalDriverMessagesHandler } from './Hooks/useExternalDriverMessagesHandler'
import { ExternalDriverFormData } from './Stores/ExternalDriverViewStore'

export const ExternalDriverFormPage = observer(() => {
  const { t } = useTranslate()
  const navigate = useNavigate()
  const history = useHistory()
  const theme = useMinimalsTheme()

  const { appViewStore, externalDriverViewStore } = usePlanningStore()
  const { getExceptionMessage, getSuccessMessage } = useExternalDriverMessagesHandler()

  const title = externalDriverViewStore.dataToBeEdited
    ? t('editDriver', 'Edit Driver')
    : t('addDriver', 'Add Driver')

  const breadCrumbs = [
    { label: t(PATHS.masterData.title), route: PATHS.masterData.url },
    {
      label: t(PATHS.masterData.externalDrivers.title, 'External Drivers'),
      onClick: () => {
        navigate(PATHS.masterData.externalDrivers.url)
        externalDriverViewStore.setDataToBeEdited()
      },
    },
    {
      label: title,
    },
  ]

  const onSubmit = async (data: ExternalDriverFormData) => {
    const isEditMode = !!externalDriverViewStore.dataToBeEdited

    try {
      await externalDriverViewStore.onSubmit(data)
      history.goBackHistoryOrDefault('/registers/external-drivers')
      appViewStore.setShowAlert('success', getSuccessMessage(isEditMode, data.name))
      externalDriverViewStore.setDataToBeEdited()
    } catch (error: any) {
      appViewStore.setShowAlert('error', getExceptionMessage(error))
    }
  }

  return (
    <>
      <Header
        title={title}
        breadcrumbs={breadCrumbs}
        rightRenderOption={
          <>
            <Button
              size='large'
              color='inherit'
              onClick={() => {
                history.goBackHistoryOrDefault(PATHS.masterData.externalDrivers.url)
                externalDriverViewStore.setDataToBeEdited()
              }}
              variant='text'
            >
              {t('cancel', 'Cancel')}
            </Button>
            <Button
              type='submit'
              form='external-driver-form'
              size='large'
              color='primary'
              variant='contained'
            >
              {t('submit', 'Sumbit')}
            </Button>
          </>
        }
      />
      <Box padding={theme.customSpacing.l}>
        <ExternalDriverForm
          defaultValues={externalDriverViewStore.dataToBeEdited}
          externalDrivers={externalDriverViewStore.allItems}
          onSubmit={onSubmit}
        />
      </Box>
    </>
  )
})
